import React from "react";
import { Button, Alert } from "antd";

function RemoveUrlTab(props) {
  return (
    <div className="remove-url-tab">
      <Alert
        message="Please note!"
        description={
          <React.Fragment>
            <div>By deleting this URL you will not be able to:</div>
            <ul>
              <li>Receive weekly emails regarding this website's performance</li>
              <li>Monitor the loading time of your website</li>
              <li>Monitor the uptime of your website</li>
              <li>Monitor the backlinks of your website</li>
              <li>Check the top keywords of your website</li>
            </ul>
          </React.Fragment>
        }
        type="error"
        showIcon
      />

      
      <Button type="danger" onClick={props.removeTrackedWebsite} loading={props.isDeleting}>
        Remove {props.selectedWebsiteUrl}
      </Button>
    </div>
  );
}

export default RemoveUrlTab;
